@let itemData = data();

@if (isImageItem(itemData) && (itemData.type === 'image' || itemData.type === 'animation')) {
  <picture>
    @for (item of itemData.source; track item) {
      <source [media]="item.media" [srcset]="item.srcset">
    }
    <img
      [alt]="itemData.alternateText"
      [src]="itemData.src"
      [style]="imageStyle()"
      [title]="itemData.name ?? ''"
    >
  </picture>
}

@if (isVectorItem(itemData)) {
  <div [innerHTML]="itemData.svg | bypassSecurity"></div>
}

@if (isImageItem(itemData) && itemData.type === 'video') {
  <video [src]="itemData.src" autoplay loop muted>
    <img [alt]="itemData.alternateText" [src]="itemData.src">
  </video>
}
